import { Component, OnInit, OnDestroy, ViewChild, NgZone} from '@angular/core';
import { Select2OptionData } from 'ng2-select2';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import { DataTablesResponse } from './../../models/DataTablesResponse';
import { DataTableDirective } from 'angular-datatables';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-passenger-subscription',
  templateUrl: './passenger-subscription.component.html',
  styleUrls: ['./passenger-subscription.component.css']
})
export class PassengerSubscriptionComponent implements OnInit {
  
  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    isWeek: true,
    dateInterval: [
      new Date(moment().subtract(6, 'days').format('YYYY-MM-DD')),
      new Date(moment().format('YYYY-MM-DD'))
    ]
  };
  staticFilter :any;
  routeBase: string;
  dtCurrentpage: any;
  dtCurrentLen: any;
  dtIntiFlag: any;
  clients: any[];
  schools: any[];
  buses: any[];
  TauxUtilisationGeneral: any;
  TotalsubScription:any;
  dtOptions: any = {};
  passengers: any[];
  periodMaxCnx:any[];
  periodConnection: any[];
  categories: { days: string[], buses: string[] };



  public clientsData: Array<Select2OptionData>;
  public schoolsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  i = 0;
  chartData: {
    categories: any[],
    series: any[]
  };
  chartData2: {
    categories: any[],
    series: any[]
  };
  Highcharts: typeof Highcharts = Highcharts;
  chart1Options: {};
  chart2Options: {};

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private zone: NgZone
  ) { 

    this.chartData = {
      categories: [],
      series: []
    };
    this.chartData2 = {
      categories: [],
      series: []
    };
    this.periodMaxCnx = [[], []];
    this.routeBase = 'passenger';
    this.dtIntiFlag = false;
    this.route.params.subscribe(params => {
      this.dtCurrentpage = params['PgNo'];
      this.dtCurrentLen = params['PgLen'];
    });

    this.http.get(
      '/api/client/lookup'
    ).subscribe((clients: any[]) => {
      this.clients = clients;
      const array1 = [{ id: '', text: 'Choisir un client' }];
      const array2 = this.clients.map(function (client, index) {
        return { id: client.id, text: client.name };
      });
      this.clientsData = array1.concat(array2);
    });

  }
  ngOnInit(): void {

    this.route.data
      .subscribe((data: { isAssistant: boolean }) => {
        this.routeBase = 'passenger';
      });

    // Event lors de la fin d'init du dt
    $('table').on('init.dt', (event) => this.initPaginationTable());

    const columns = [
      { data: 'lastFirstname' },
      { data: 'phone' },
      { data: 'lastConnection' },
      { data: 'connectionCounter' },
      { data: 'appVersion' },
      { data: 'actions' },
    ];
    
    this.dtOptions = {
      searching: false,
      pageLength: Number(this.dtCurrentLen),
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/passengerSubscription',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.passengers = resp.data;
          let dta = [];
          this.passengers.forEach((passenger, index) => {
            dta.push({
              id: passenger.id,
              lastFirstname: passenger.lastname + '-' + passenger.firstnames,
              phone: passenger.phone,
              lastConnection: passenger.lastConnection,
              connectionCounter: passenger.connectionCounter,
              appVersion: passenger.appVersion,
              actions: `
                <a class="btn btnAction btnNavigate" href="" data-toggle="modal" data-target="#ModalAlert">
                  <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
                 </a>
                `
            });
          });

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'passenger_' + aData.id);
      },
      columns: columns,
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
    $('table').on('click', '.btnNavigate', (event) => {
      this.onDetails($(event.currentTarget).data('passengerId'));
    });
    $('table').on('draw.dt', (event) => this.onDtDrawChange());

  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }

  onDtDrawChange() {
    this.updatePaginationInfo();
  }

  onDetails(id) {
    let selectedpassenger;
    this.passengers.forEach((passenger) => {
      if (id == passenger.id){
        selectedpassenger = passenger;
        selectedpassenger.SmsToSend = 1;
        window.alert(selectedpassenger.lastname + ' ' + selectedpassenger.SmsToSend);
      }
    });

    /* this.http.put(
        '/api/passenger/' + id,
        { passenger: selectedpassenger }
      ).subscribe();
      this.pnotify.notice({
      title: 'Information',
      text: 'La demande d\'envoie SMS est enregirstré',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    }); */
  }

  initPaginationTable(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      const pgsInfo = dtInstance.page.info();
      const totalPg = pgsInfo.pages;
      let pgNo  = 0;

      if (this.dtCurrentpage === 'last' ) {
        pgNo = totalPg - 1;
      } else {
        pgNo = Number(this.dtCurrentpage);
      }
      // dtInstance.page.len(Number(this.dtCurrentLen));
      dtInstance.page(pgNo);
      dtInstance.draw(false);
      this.dtIntiFlag = true;
   });
  }

  updatePaginationInfo(): void {
    if (this.dtIntiFlag === true) {
      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        const pgsInfo = dtInstance.page.info();
        this.dtCurrentpage = pgsInfo.page;
        this.dtCurrentLen = pgsInfo.length;
     });
    }
  }


  clientChanged(e: any) {
    this.filter.clientId = e.value;
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      const array1 = [{ id: '', text: 'Choisir une école' }];
      const array2 = this.schools.map(function (school, index) {
        return { id: school.id, text: school.name };
      });
      this.schoolsData = array1.concat(array2);
    });
  }
  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  initBusSelect() {
    this.filter.busId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir une option' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);
    });
  }

  busChanged(e: any) {
    this.filter.busId = e.value;
    this.staticFilter = this.filter;
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
   });
  }

  loadHighCharts1Options() {
    this.chart1Options = {
      chart: {
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },
      title: {
        text: ''
      },
      xAxis: {
        min: 0,
        title: {
          text: null
        },
        categories: this.chartData.categories,
        // labels: {
        //   formatter: () => {
        //     this.i++;
        //     return this.chartData[this.i].name;
        //   }
        // },
        lineWidth: 2
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
        labels: {
          formatter: function () {
            return Math.round(this.value);
          }
        },
      },
      tooltip: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            formatter: function () {
              return Math.round(this.y) ;
            },
          },
        },
      },
      series: [{
        data: this.chartData.series,
        type: 'column'
      }]
    };
  }

  loadHighCharts2Options() {
    this.chart2Options = {
      chart: {
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)'
      },
      title: {
        text: ''
      },
      colors: ['#f16e00'],
      xAxis: {
        title: {
          text: ''
        },
        labels: {
          rotation: -45,
        },
        categories: this.chartData2.categories,
        lineWidth: 2,
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
        labels: {
          formatter: function () {
            return Math.round(this.value);
          }
        },
      },
      tooltip: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return Math.round(this.y);
            }
          },
        },
      },
      series: [
        {
          name: '',
          data: this.chartData2.series,
          // type: 'column'
        }
      ]
    };
  }

  onFilter() {
    this.chartData = {
      categories: [],
      series: []
    };
    this.chartData2 = {
      categories: [],
      series: []
    };
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    const params = new HttpParams({
      fromObject: {
        schoolId: this.staticFilter.schoolId,
        dateInterval: JSON.stringify([
          moment(this.filter.dateInterval[0]).format('YYYY-MM-DD'),
          moment(this.filter.dateInterval[1]).format('YYYY-MM-DD')
        ])
      }
    });
    this.http.get(
      '/api/passengerSubscription/subscriptionInfo',
      { params }
    ).subscribe((data: any) => {
      // Distribution per Bus
      data.busesSubscriptionsCount.forEach((elt, idx) => {
        this.chartData.categories.push(elt['Bus.name']);
        this.chartData.series.push(parseInt(elt['usersCount'])); // parseInt: convert to init before push
        // console.log('Info :  ' + elt['Bus.name'] + ' ' + parseInt(elt['usersCount']));
      });

      // Distribution per days
      this.chartData2.categories  = data.days;
      this.chartData2.series = data.periodConnection;
  
      
      this.loadHighCharts1Options();
      this.loadHighCharts2Options();
      this.TauxUtilisationGeneral = data.TauxPerformanceGeneral;
      this.TotalsubScription = data.TotalsubScriptionUsers;
    });
  }
}





// WEBPACK FOOTER //
// ./src/app/components/passenger-subscription/passenger-subscription.component.ts